<template>
  <div>
    <div class="header">
      <!-- <h3>农村产权交易</h3>
      <p>唤醒农村沉睡的资产 | 增加农民资产性收入 | 主推新农村建设步伐</p>
      <span>你的需求就是我们的目标 你的满意就是我们的追求</span><br>
      <button>查看详细</button> -->

      <el-carousel height="670px">
        <el-carousel-item v-for="(item, index) in lunbo" :key="index">
          <router-link :to="{ name: '新闻中心详情', query: { id: item.id } }">
            <img
              :src="requestUrl + item.img"
              :alt="item.title"
              class="lunbo_img"
            />
          </router-link>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      lunbo: [

      ],
      navs: [
        {
          name: "首页"
        },
        {
          name: "新闻中心"
        },
        {
          name: "交易项目"
        },
        {
          name: "电子竞价"
        },
        {
          name: "交易指南"
        },
        {
          name: "政策法规"
        },
        {
          name: "资料下载"
        },
        {
          name: "关于我们"
        }
      ],
      title: ''
    }
  },

  mounted () {
  },
  created () {
    // 轮播新闻数据
    let url = "news/rotation"
    // console.log(this.ajax_url(url));
    this.lunbo = this.ajax_url1(url).data
    console.log(this.lunbo)
  },
  computed: {},
  updated () {

  },
  watch: {},
  methods: {
    toQuanzhan () {
      this.$router.push({ name: "全站搜索", query: { id: this.title } })
    },
  }

};
</script>

<style scoped>
.header {
  z-index: -1;
  /* border: red 1px solid; */
  margin-top: 3px;
  width: 100%;
  height: 670px;
  /* background-color: aqua; */
  /* background: url("../assets/img/bj.png") no-repeat; */
  /* background-position: top center;
  background-size: 100% 257px; */
  position: absolute;
  top: 3px;
  text-align: center;
}

.lunbo_img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.el-carousel /deep/ .el-carousel__indicators--horizontal .el-carousel__button {
  width: 15px;
  height: 15px;
  border-radius: 50%;
}

.el-carousel /deep/ .el-carousel__indicator--horizontal {
  padding: 12px 10px;
}

.el-carousel /deep/ .el-carousel__indicators--horizontal {
  /* left: 100px; */
  bottom: 100px;
  transform: none;
}
</style>
